import { render, staticRenderFns } from "./allianceBusinessList.vue?vue&type=template&id=88006292&scoped=true"
import script from "./allianceBusinessList.vue?vue&type=script&lang=ts"
export * from "./allianceBusinessList.vue?vue&type=script&lang=ts"
import style0 from "./allianceBusinessList.vue?vue&type=style&index=0&id=88006292&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88006292",
  null
  
)

export default component.exports